import {
    useEffect, useState
} from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorProfileLocale } from '../../app';
import { updateAppLocale } from '../../app/state/app.actions';
import { useSelectorConfigValue } from '../../configuration';
import { loadI18n } from '../utils/locale-utils';

type Options = {
    baseUrl?: string
};

type State = {
    isError: boolean
};

/**
 * This hook will load the required data once for the before the application is ready to
 * render for the first time.
 */
export function useActivateI18n (options?: Options) {
    const [state, setState] = useState<State>({ isError: false });
    const localisationCdnBaseUrl = useSelectorConfigValue(
        'LocalisationCdnBaseUrl',
        'local'
    );
    const dispatch = useDispatch();
    const {
        locale, isLocaleLoaded
    } = useSelectorProfileLocale();

    // Load the required i18n data dynamically either from CDN or a local bundle
    useEffect(() => {
        if (isLocaleLoaded || !locale) {
            return;
        }

        loadI18n({
            ...options,
            ...localisationCdnBaseUrl && { localisationCdnBaseUrl },
            locale
        }).then(({ locale }) => {
            dispatch(updateAppLocale({ localeLoaded: locale }));
        }).catch((error: unknown) => {
            console.error('useActivateI18n unable to load i18n json data or fallback', error);

            setState({ isError: true });
            dispatch(updateAppLocale({ localeLoaded: null }));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isLocaleLoaded, locale]);

    return {
        ...state,
        isLoaded: isLocaleLoaded
    };
}
